/* LeParfin : quiz (maquette V3, fonction quiz ; V8 : deux questions et accord du parfum dans le trio).
   Une question à la fois, score par parfum (poids de la question), résultat avec le parfum en tête,
   trio conseillé (les trois premiers du classement, ajoutés via [data-add-many] de theme.js). */
(() => {
  'use strict';

  const fallbackMoney = cents => (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  const money = cents => (window.LP && typeof window.LP.money === 'function' ? window.LP.money(cents) : fallbackMoney(cents));

  function setup(root) {
    if (!root || root.__lpQuiz) return;
    root.__lpQuiz = true;

    let cfg = {};
    const dataEl = root.querySelector('[data-lp-quiz-data]');
    if (dataEl) { try { cfg = JSON.parse(dataEl.textContent) || {}; } catch (e) { cfg = {}; } }

    const steps = [...root.querySelectorAll('[data-quiz-step]')];
    const results = [...root.querySelectorAll('[data-quiz-result]')];
    const spacer = root.querySelector('[data-quiz-spacer]');
    const order = results.map(r => r.getAttribute('data-quiz-result'));
    let state = { step: 0, ans: [] };

    /* Recette V10 : images des questions suivantes chargées dès la fin du chargement de la page (plus de cartes vides à la question 2). */
    const warmSteps = () => steps.slice(1).forEach(s => s.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; }));
    if (document.readyState === 'complete') setTimeout(warmSteps, 300);
    else window.addEventListener('load', () => setTimeout(warmSteps, 300), { once: true });

    function reveal(el) {
      el.hidden = false;
      el.classList.remove('fade');
      void el.offsetWidth;
      el.classList.add('fade');
    }

    function toTop(el) {
      const y = root.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: y < window.innerHeight ? 0 : y, behavior: 'instant' });
      const h = el && el.querySelector('h1');
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }

    function showStep(i, scroll) {
      results.forEach(r => { r.hidden = true; });
      steps.forEach((s, j) => { if (j === i) reveal(s); else s.hidden = true; });
      if (spacer) spacer.hidden = false;
      if (scroll) toTop(steps[i]);
    }

    function showResult() {
      const score = {};
      state.ans.forEach((a, qi) => {
        if (!a) return;
        const w = parseInt((steps[qi] && steps[qi].getAttribute('data-weight')) || '1', 10) || 1;
        a.keys.forEach(k => { if (order.includes(k)) score[k] = (score[k] || 0) + w; });
      });
      const gift = state.ans.some(a => a && a.gift);
      const rank = () => order.slice().sort((a, b) => (score[b] || 0) - (score[a] || 0));
      let ranked = rank();
      /* V8 : l'accord du parfum en tête (data-duo, réglage « Accord » du thème) reçoit un demi-point :
         il passe devant les parfums à égalité, sans jamais dépasser une vraie réponse. */
      if (cfg.duoBonus !== false && ranked.length && (score[ranked[0]] || 0) > 0) {
        const head = results.find(r => r.getAttribute('data-quiz-result') === ranked[0]);
        const duo = head ? (head.getAttribute('data-duo') || '').trim().toLowerCase() : '';
        if (duo && duo !== ranked[0] && order.includes(duo)) {
          score[duo] = (score[duo] || 0) + 0.5;
          ranked = rank();
        }
      }
      const top = ranked[0];
      const trio = ranked.slice(0, 3);
      const res = results.find(r => r.getAttribute('data-quiz-result') === top);
      if (!res) return;

      const caps = trio.map(k => { const r = results.find(x => x.getAttribute('data-quiz-result') === k); return r ? r.getAttribute('data-cap') : k; });
      const ids = trio.map(k => { const r = results.find(x => x.getAttribute('data-quiz-result') === k); return r ? r.getAttribute('data-variant') : ''; }).filter(Boolean);
      const prices = trio.map(k => { const r = results.find(x => x.getAttribute('data-quiz-result') === k); return r ? parseInt(r.getAttribute('data-price') || '0', 10) : 0; });
      const trioCents = prices.reduce((a, b) => a + b, 0) - (prices.length >= 3 ? Math.min(...prices) : 0);

      const btn = res.querySelector('[data-quiz-trio]');
      if (btn) {
        btn.setAttribute('data-add-many', ids.join(','));
        btn.disabled = !ids.length;
        const pr = btn.querySelector('[data-quiz-trio-price]');
        if (pr && trioCents > 0) pr.textContent = money(trioCents);
      }
      const txt = res.querySelector('[data-quiz-trio-text]');
      if (txt) {
        let t = (cfg.trioText || '').replace('[trio]', caps.join(', '));
        if (gift && cfg.giftText) t += (t ? ' ' : '') + cfg.giftText;
        txt.textContent = t;
        txt.hidden = !t;
      }

      steps.forEach(s => { s.hidden = true; });
      results.forEach(r => { if (r !== res) r.hidden = true; });
      if (spacer) spacer.hidden = true;
      reveal(res);
      toTop(res);
    }

    root.addEventListener('click', e => {
      const t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-qa')) {
        e.preventDefault();
        const keys = (t.getAttribute('data-keys') || '').split(',').map(s => s.trim()).filter(Boolean);
        state.ans[state.step] = { keys, gift: t.getAttribute('data-gift') === '1' };
        state.step += 1;
        if (state.step >= steps.length) showResult();
        else showStep(state.step, true);
        return;
      }
      if (t.hasAttribute('data-qback')) {
        e.preventDefault();
        state.step = Math.max(0, state.step - 1);
        showStep(state.step, true);
        return;
      }
      if (t.hasAttribute('data-qreset')) {
        e.preventDefault();
        state = { step: 0, ans: [] };
        showStep(0, true);
      }
    });

    if (steps.length) showStep(0, false);
    else if (results.length) showResult();
  }

  const init = (scope = document) => {
    if (scope.matches && scope.matches('[data-lp-quiz]')) setup(scope);
    scope.querySelectorAll('[data-lp-quiz]').forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const root = e.target.closest('[data-lp-quiz]');
    if (!root) return;
    const step = e.target.closest('[data-quiz-step]');
    if (!step) return;
    root.querySelectorAll('[data-quiz-result]').forEach(r => { r.hidden = true; });
    root.querySelectorAll('[data-quiz-step]').forEach(s => { s.hidden = s !== step; });
  });
})();
